module.exports = __webpack_public_path__ + "img/cases-brand-tommee-lazyload-41.d9d7de40.jpg";